import { StoreModel } from '../../models/Index';

// eslint-disable-next-line import/no-anonymous-default-export
export default function emailReceipt(Store: StoreModel, event: any) {
    return Store.emailReceipt(event.data);
}
